<script setup lang="ts">
const options = ref({
  penColor: 'rgb(0,0,0)',
  backgroundColor: 'rgb(255, 255, 255)',
  maxWidth: 2,
  minWidth: 1
})
const signature = ref()

const props = defineProps({
  context: Object
})

const defaultUrl = computed(() => {
  const val = props.context?._value
  if (!val) return ''
  if (val.startsWith('data:')) return val
  return `data:image/png;base64,${val}`
})

const clearSignature = () => {
  signature.value.clearCanvas()
  props.context.node.input(null)
}

const saveSignature = () => {
  const dataUrl = signature.value.saveSignature('image/png')
  props.context.node.input(dataUrl.split(',')[1])
}
</script>

<template>
  <div
    id="signpad-container"
    class="border border-(--grid-border) rounded shadow-md overflow-hidden p-2"
  >
    <NuxtSignaturePad
      ref="signature"
      width="100%"
      height="200px"
      :default-url="defaultUrl"
      :max-width="options.maxWidth"
      :min-width="options.minWidth"
      :options="{
        penColor: options.penColor,
        backgroundColor: options.backgroundColor
      }"
      @end-stroke="saveSignature"
    />

    <div
      data-html2canvas-ignore
      class="flex justify-center mt-4"
    >
      <UButton
        variant="outline"
        @click="clearSignature"
      >
        Limpar assinatura
      </UButton>
    </div>
  </div>
</template>
